import PropTypes from 'prop-types'
import React from 'react'
import CustomerForm from '../Form'

export const EditCustomer = (props) => <CustomerForm {...props} editing />

EditCustomer.propTypes = {
  customer: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,

  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default EditCustomer



// WEBPACK FOOTER //
// ./src/components/Customers/Edit/EditCustomer.js